export default {
  getMaintenance: ({ maintenance }) => maintenance,
};



// WEBPACK FOOTER //
// ./src/vuex/maintenance/maintenanceGetter.js